// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useMemo} from 'react';
import cn from 'classnames';
import {Tooltip} from '@pub/comp/tooltip';
import * as srcs from './list.js';
import * as cns from './svg.module.less';

const img_style = {display: 'inline-flex', width: '100%', height: '100%'};
const get_alt = (alt, name)=>alt || name;

function Img_inner({
    className,
    alt,
    name,
    src,
    size,
    flexible,
    tooltip_text,
    tooltip_placement,
})
{
    const style = useMemo(()=>{
        const res = {...img_style};
        if (!flexible)
        {
            res.height = size+'px';
            res.width = size+'px';
        }
        return res;
    }, [size, img_style, flexible]);
    return <Tooltip tip={tooltip_text} placement={tooltip_placement}>
      <img className={className} style={style} src={src}
        alt={get_alt(alt, name)}/>
    </Tooltip>;
}

function Span_inner({
    className,
    alt,
    name,
    size,
    src,
    tooltip_text,
    tooltip_placement,
})
{
    const style = useMemo(()=>({
        'WebkitMaskImage': `url("${src}")`,
        height: size+'px',
        width: size+'px',
    }), [src, size]);
    if (!size)
        throw new Error('Svg as span: size is required');
    return <Tooltip tip={tooltip_text} placement={tooltip_placement}>
      <span className={cn(className, cns.span)} style={style}
        aria-label={get_alt(alt, name)}/>
    </Tooltip>;
}

export const exists = name=>!!srcs[name];

function Wrap({
    className,
    name,
    alt,
    size=20,
    flexible,
    as='img',
    tooltip_text,
    tooltip_placement,
})
{
    let src = srcs[name];
    if (!src)
    {
        console.error('Svg: unknown svg name '+name);
        src = srcs.ico_question;
    }
    const Comp = as=='img' ? Img_inner : Span_inner;
    return <Comp className={cn(className)} name={name} alt={alt}
      size={size} flexible={flexible} src={src} tooltip_text={tooltip_text}
      tooltip_placement={tooltip_placement}/>;
}

export const Svg = React.memo(Wrap);
